import { Button, TableProps } from "antd";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import SortIcon from "../../assets/icons/SortIcon";
import ViewIcon from "../../assets/icons/ViewIcon";
import IMG2 from "../../assets/images/dashboard/bus 1.svg";
import IMG1 from "../../assets/images/dashboard/fast-food 1.svg";
import IMG4 from "../../assets/images/dashboard/taka 1.svg";
import IMG3 from "../../assets/images/dashboard/ui-file 1.svg";
import { useGetAnnouncementListQuery } from "../../features/announcement/announcementApi";
import { useGetDashboardExpenseQuery } from "../../features/expense/expenseApi";
import useError from "../../hooks/useError";
import useModal from "../../hooks/useModal";
import { AnnouncementData } from "../../types";
import { addKeyInArray } from "../../utils/utils";
import ViewManageAnnouncement from "../Announcement/ViewManageAnnouncement";
import CustomTable from "../ui/CustomTable";
import HeaderTitle from "./HeaderTitle";
import TopBarCard from "./TopBarCard";

enum Status {
  Published = "status-success",
  Scheduled = "status-info",
  Expired = "status-dark",
}

export default function ExpanseForDashboard() {
  const { open, handleClose, handleOpen } = useModal();
  const { isLoading, isError, error, data } = useGetAnnouncementListQuery({
    params: {
      skip: 0,
      limit: 5,
    },
  });
  const {
    isError: isExpanseError,
    error: expanseError,
    data: expanseData,
  } = useGetDashboardExpenseQuery({
    params: {
      month: dayjs().format("YYYY-MM"),
    },
  });
  useError(isError, error, "Get announcement data fail");
  useError(isExpanseError, expanseError, "Get expanse data fail");

  const dataList = expanseData?.data;

  const topBarData = [
    {
      title: "Food",
      count: (
        <>
          {dataList?.totalFood}
          <span className="text-2xl">BDT</span>
        </>
      ),
      color: "#FFF6ED",
      img: IMG1,
      titleCount: dataList?.foodUserCount,
      link: "/admin/expense",
    },
    {
      title: "Transport",
      count: (
        <>
          {dataList?.totalTransport}
          <span className="text-2xl">BDT</span>
        </>
      ),
      color: "#FFF5F4",
      img: IMG2,
      titleCount: dataList?.transportUserCount,
      link: "/admin/expense",
    },
    {
      title: "Others",
      count: (
        <>
          {dataList?.totalOther}
          <span className="text-2xl">BDT</span>
        </>
      ),
      color: "#F4F5FF",
      img: IMG3,
      titleCount: dataList?.otherUserCount,
      link: "/admin/expense",
    },
    {
      title: "Total",
      count: (
        <>
          {dataList?.totalExpense}
          <span className="text-2xl">BDT</span>
        </>
      ),
      color: "#F3FAFF",
      img: IMG4,
      link: "/admin/expense",
    },
  ];

  const columns: TableProps<AnnouncementData>["columns"] = [
    {
      title: "#SL",
      align: "center",
      width: 60,
      render: (_, __, index) => index + 1,
    },
    {
      title: "Type",
      dataIndex: "type",
    },
    {
      title: "Title",
      dataIndex: "title",
    },
    {
      title: "Created On",
      dataIndex: "start_date",
      sorter: (a, b) =>
        dayjs(a.start_date, "MMM DD, YYYY, hh:mm A").valueOf() -
        dayjs(b.start_date, "MMM DD, YYYY, hh:mm A").valueOf(),
      sortIcon: () => <SortIcon />,
    },
    {
      title: "Ends On",
      dataIndex: "end_date",
    },
    {
      title: "Applicable for",
      dataIndex: "target_type",
    },
    {
      title: "Status",
      dataIndex: "status",
      render: (value: keyof typeof Status) => (
        <span className={Status[value]}>{value}</span>
      ),
    },
    {
      title: "Actions",
      dataIndex: "id",
      align: "center",
      render: (val) => (
        <div className="flex justify-center items-center gap-2">
          <Button
            className="action-button"
            size="small"
            icon={<ViewIcon />}
            onClick={() =>
              handleOpen({
                type: "VIEW",
                data: val,
              })
            }
          />
        </div>
      ),
    },
  ];

  return (
    <div className="mt-6">
      <HeaderTitle title="Expense" />

      <div className="grid md:grid-cols-4 sm:grid-cols-2 gap-6 mb-6">
        {topBarData?.map((item) => (
          <TopBarCard
            key={item.title}
            title={item.title}
            count={item.count}
            color={item.color}
            titleCount={item.titleCount}
            img={item.img}
            link={item.link}
          />
        ))}
      </div>

      <HeaderTitle title="recent Announcements">
        <Link
          to="/admin/announcement"
          className="text-primary font-medium hover:text-primary/80"
        >
          See all
        </Link>
      </HeaderTitle>

      <CustomTable
        loading={isLoading}
        columns={columns}
        dataSource={addKeyInArray(data?.data?.announcements)}
        className="header-table-white-color"
      />

      {open.type === "VIEW" && (
        <ViewManageAnnouncement
          open={open.open}
          data={open?.data}
          handleClose={handleClose}
          handleEditOpen={handleOpen}
        />
      )}
    </div>
  );
}
